import IGetSiteDiaryResponseModel from "interfaces/Response/IGetSiteDiaryResponseModel";
import AuthorisedMaintenanceProps from "interfaces/SiteDiary/AuthorisedMaintenance/AuthorisedMaintenanceProps";
import IAuthorisedMaintenanceDetailsModel from "interfaces/SiteDiary/AuthorisedMaintenance/IAuthorisedMaintenanceDetailsModel";
import ISiteDiaryAuthorisedMaintenanceViewModel from "interfaces/SiteDiary/AuthorisedMaintenance/ISiteDiaryAuthorisedMaintenanceViewModel";

function mapGetSiteDiaryResponseModelToAuthorisedMaintenance(
  siteDiaryResponseModel: IGetSiteDiaryResponseModel,
  diarySaved: boolean,
  diaryDate:string,
  hwrcSiteId: string
): AuthorisedMaintenanceProps {
  const authorisedMaintenanceProps: AuthorisedMaintenanceProps = {
    authorisedMaintenanceDetails: [],
    diarySaved,
    diaryDate,
    hwrcSiteId
  };

  if (
    siteDiaryResponseModel.siteDiary
    && siteDiaryResponseModel.siteDiary.authorisedMaintenance
  ) {
    siteDiaryResponseModel.siteDiary.authorisedMaintenance.forEach(entry => {
      const details : ISiteDiaryAuthorisedMaintenanceViewModel = {
        hwrcSiteId,
        diaryDate,
        id: entry.id,
        details: entry.details,
        undertakenBy: entry.undertakenBy,
        atwPtwNumber: entry.atwPtwNumber,
        childData: entry.id && entry.details ? [{
          id: entry.id,
          details: entry.details
        } as IAuthorisedMaintenanceDetailsModel] : []
      };

      authorisedMaintenanceProps.authorisedMaintenanceDetails.push(details);
    });
  }
  return authorisedMaintenanceProps;
}

export { mapGetSiteDiaryResponseModelToAuthorisedMaintenance };
